import CheckIcon from '@mui/icons-material/Check'
import DeleteIcon from '@mui/icons-material/Delete'
import SearchIcon from '@mui/icons-material/Search'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputAdornment,
  InputBase,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from '@mui/material'
import { ITableHeadCellDTO } from 'data/dtos/components/i-table-head-cell-dto'
import React, { ChangeEvent, Dispatch, MouseEvent, SetStateAction, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useStyles } from './styles'

type Props = {
  headCells: ITableHeadCellDTO[]
  rows: any[]
  totalRows: number
  handleSearch: Dispatch<SetStateAction<string>>
  isLoading: number
  handleChangeRowsPerPage: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => Promise<void>
  rowsPerPage: number
  handleChangePage: (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => void
  page: number
  editRoute: string
  handleDelete: () => void
  handleRecordToDelete: Dispatch<SetStateAction<string | null>>
  orderByDirection: boolean
  setOrderByDirection: Dispatch<SetStateAction<boolean>>
  columnOrder: ('ASC' | 'DESC')[]
  setColumnOrder: Dispatch<SetStateAction<('ASC' | 'DESC')[]>>
}

const formatString = (fieldContent: string, format: string) => {
  let output = fieldContent

  if (typeof fieldContent == 'boolean' && fieldContent == true) {
    output = 'X'
  }

  switch (format) {
    case 'cnpj':
      output = output.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
  }

  return output
}

const CustomTable: React.FC<Props> = ({
  headCells,
  rows,
  totalRows,
  handleSearch,
  isLoading,
  handleChangeRowsPerPage,
  rowsPerPage,
  handleChangePage,
  page,
  editRoute,
  handleDelete,
  handleRecordToDelete,
  orderByDirection,
  setOrderByDirection,
  columnOrder,
  setColumnOrder,
}: Props) => {
  const [open, setOpen] = useState(false)
  // const [selectedCheckbox, setSelectedCheckbox] = useState<string[]>([])

  const classes = useStyles()
  const history = useHistory()
  const defaultWidth = headCells.length > 1 ? 100 / headCells.length : 100

  const handleClickOpen = (record: string) => {
    setOpen(true)
    handleRecordToDelete(record)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleCloseDelete = () => {
    setOpen(false)
    handleDelete()
  }

  const handleSortChange = (index: number) => {
    columnOrder[index] = columnOrder[index] === 'ASC' ? 'DESC' : 'ASC'

    setColumnOrder(columnOrder)
    setOrderByDirection(!orderByDirection)
  }

  // const handleCheckboxClicked = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, id: string) => {
  //   if (selectedCheckbox.includes(id)) {
  //     setSelectedCheckbox(selectedCheckbox.splice(selectedCheckbox.indexOf(id), 1))
  //   } else {
  //     setSelectedCheckbox([...selectedCheckbox, id])
  //   }
  //   e.stopPropagation()
  // }

  const handleDeleteButton = (e: any, id: string) => {
    e.stopPropagation()
    handleClickOpen(id)
  }

  useEffect(() => {
    const sortArray: Array<'ASC' | 'DESC'> = headCells.map(() => 'ASC')

    setColumnOrder(sortArray)
  }, [headCells])

  return (
    <>
      <div className={classes.search}>
        <InputBase
          placeholder={'Buscar'}
          className={classes.inputInput}
          onChange={(e) => {
            handleSearch(e.target.value)
          }}
          endAdornment={
            <InputAdornment position='end'>
              <IconButton edge='end'>
                <SearchIcon style={{ fontSize: '120%', color: '#212121' }} />
              </IconButton>
            </InputAdornment>
          }
        />
      </div>

      <div className={isLoading === 1 ? classes.linearProgressOn : classes.linearProgressOff}>
        <LinearProgress />
      </div>

      <Paper
        elevation={0}
        className={classes.tablePaper}
      >
        <TableContainer className={classes.tableContainer}>
          <Table
            sx={{
              borderCollapse: 'separate',
              borderSpacing: '0px 10px',
            }}
          >
            <TableHead>
              <TableRow key={0}>
                {/* <TableCell className={classes.rowTableIcon}><Checkbox /></TableCell> */}

                {headCells.map((headCell, index) => (
                  <TableCell
                    align='left'
                    style={{
                      width: `${
                        typeof headCell.width !== 'undefined' ? (headCell.width * 100) / 10 : defaultWidth
                      }%`,
                      fontWeight: 'bold',
                      color: '#212121 !important',
                    }}
                  >
                    <TableSortLabel
                      active={true}
                      direction={columnOrder[index] === 'ASC' ? 'asc' : 'desc'}
                      onClick={() => handleSortChange(index)}
                      style={{
                        fontWeight: 'bold',
                        color: '#212121 !important',
                      }}
                    >
                      {headCell.label}
                    </TableSortLabel>
                  </TableCell>
                ))}

                <TableCell className={classes.rowTableIcon}> &nbsp;</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => (
                <TableRow
                  hover
                  key={row.id}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    if (editRoute != 'undefined') {
                      history.push(`${editRoute}/${row.id}`)
                    }
                  }}
                >
                  {/* <TableCell className={classes.rowTableIcon}><Checkbox
                    value={selectedCheckbox.includes(row.id)}
                    checked={selectedCheckbox.includes(row.id)}
                    onClick={(e) => handleCheckboxClicked(e, row.id)}
                  /> </TableCell> */}

                  {headCells.map((headCell) => (
                    <TableCell
                      align='left'
                      style={{ minWidth: 100 }}
                    >
                      {headCell.id.includes('.') ? (
                        formatString(
                          row[headCell.id.split('.')[0]][headCell.id.split('.')[1]],
                          headCell.format ?? ''
                        )
                      ) : formatString(row[headCell.id], headCell.format ?? '') == 'X' ? (
                        <CheckIcon className={classes.tableIcon} />
                      ) : (
                        formatString(row[headCell.id], headCell.format ?? '')
                      )}
                    </TableCell>
                  ))}
                  <TableCell className={classes.rowTableIcon}>
                    <DeleteIcon
                      className={classes.tableIcon}
                      onClick={(e) => handleDeleteButton(e, row.id)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component='div'
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage='Linhas por página'
          labelDisplayedRows={({ from, to, count }) => `Página ${page + 1}, ${from}-${to} de ${count}`}
          sx={{
            '.MuiSvgIcon-root': {
              position: 'relative',
            },
          }}
        />
      </Paper>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>Exclusão de Registro</DialogTitle>

        <DialogContent style={{ width: '500px' }}>
          <DialogContentText id='alert-dialog-description'>
            Deseja realmente excluir o registro?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleClose}
            variant='contained'
          >
            Não
          </Button>
          <Button
            onClick={handleCloseDelete}
            variant='contained'
          >
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export { CustomTable }
